import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/classroomInteraction/common/tick.png'


_pushScopeId("data-v-2ef35b68")
const _hoisted_1 = { class: "stu-card-body-subscript" }
const _hoisted_2 = {
  class: "subscript-image",
  src: _imports_0
}
const _hoisted_3 = { class: "stu-card-avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "stu-card-avatar-start" }
const _hoisted_6 = { class: "stu-card-avatar-star-0" }
const _hoisted_7 = { class: "stu-card-avatar-star-1" }
const _hoisted_8 = { class: "stu-card-avatar-star-2" }
const _hoisted_9 = { class: "stu-card-avatar-star-3" }
const _hoisted_10 = { class: "stu-card-avatar-star-4" }
const _hoisted_11 = { class: "stu-card-avatar-animation" }
const _hoisted_12 = { class: "stu-card-content-point" }
const _hoisted_13 = { class: "stu-card-content-footer" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "score-both" }
const _hoisted_16 = { class: "score-both-add" }
const _hoisted_17 = { class: "score-both-reduce" }
const _hoisted_18 = { class: "score-both" }
const _hoisted_19 = {
  key: 0,
  class: "score-single-add"
}
const _hoisted_20 = {
  key: 1,
  class: "score-single-reduce"
}
const _hoisted_21 = { class: "score-both" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "score-single-zero" }, "0", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "stu-card-content-subscript" }
const _hoisted_25 = {
  class: "foot-subscript-image",
  src: _imports_0
}
const _hoisted_26 = { class: "stu-card-name-label" }
_popScopeId()

import {
  PropType,
  computed,
  CSSProperties,
} from "vue";

type StudentInfo = {
  name: string;
  avatar?: string;
  id: number | string;
  py_name: string;
  score?: {
    add?: { value: number };
    reduce?: { value: number };
  };
  [key: string]: any;
};

type SelectTypeValue = "UP" | "DOWN";


export default _defineComponent({
  props: {
  // 基本信息
  info: {
    type: Object as PropType<StudentInfo>,
    default: () => ({
      name: "",
      avatar: "stu_avatar_1.jpg",
      py_name: "",
      id: Date.now(),
      score: undefined,
    }),
  },
  // 是否选中
  isSelect: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  // 选中角标显示在上还是下
  selectType: {
    type: String as PropType<SelectTypeValue>,
    default: "UP",
  },
  // 是否显示成绩
  showScore: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  // 名字部分的样式注入
  nameStyle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  // 头像部分的样式注入
  avatarSytle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  // 正文部分的样式注入
  contentSytle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  showStar: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  // 加分蒙层效果
  scoreAnimation: {
    type: Object as PropType<{ visible: boolean; score: number }>,
    default: () => ({ visible: false, score: 1 }),
  },
},
  emits: ["onClick"] as unknown as undefined,
  setup(__props, { emit }: { emit: ({
  (event: "onClick", id: number | string, info: StudentInfo): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
const AllStudentId = "ALL_STUDENT";

const SelectTypeEnum: { [key: string]: SelectTypeValue } = {
  UP: "UP",
  DOWN: "DOWN",
};





const studentInfo = computed<StudentInfo>(() => props.info);
const isSelect = computed<boolean>(() => props.isSelect);
const selectType = computed<string>(() => props.selectType);

const showScore = computed(() => props.showScore);
const score = computed(() => props.info.score);

const nameStyleCompu = computed(() => props.nameStyle);
const avatarSytleCompu = computed(() => props.avatarSytle);
const contentSytleCompu = computed(() => props.contentSytle);
const isNoAllClass = computed<boolean>(() => props.info.id !== AllStudentId);

const showStarCompu = computed<boolean>(() => props.showStar);

const animationVisible = computed(() => props.scoreAnimation.visible);
const animationNum = computed(() => props.scoreAnimation.score);

const starNum = computed(() => {
  const n = (score.value?.add?.value || 0) - (score.value?.reduce?.value || 0);
  return parseInt("" + (n >= 0 ? (n >= 4 ? 4 : n) : 0));
});

const handleClick = () => {
  emit("onClick", studentInfo.value.id, studentInfo.value);
};

// 兼容本地图片地址的url和网络地址的url
const getUrlInfo = (url: string): any => {
  const reg = /http[s]{0,1}:/gi;
  // 网络地址，直接用
  if (reg.test(url)) {
    return url;
  }
  const img = require("@/assets/img/classroomInteraction/stuAvatar/" + url);
  return img;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "stu-card-body",
    onClick: handleClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "subscript", {}, () => [
        _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
          [_vShow, _unref(isNoAllClass) && _unref(isSelect) && _unref(selectType) === SelectTypeEnum.UP]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "stu-card-content",
      style: _normalizeStyle(_unref(contentSytleCompu))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          draggable: "false",
          class: "stu-card-avatar-image",
          src: getUrlInfo(_unref(studentInfo)?.avatar || ''),
          style: _normalizeStyle(_unref(avatarSytleCompu))
        }, null, 12, _hoisted_4),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
            [_vShow, _unref(starNum) === 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
            [_vShow, _unref(starNum) === 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
            [_vShow, _unref(starNum) === 2]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
            [_vShow, _unref(starNum) === 3]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
            [_vShow, _unref(starNum) === 4]
          ])
        ], 512), [
          [_vShow, _unref(showStarCompu)]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("div", { class: "stu-card-avatar-animation-add" }, " +" + _toDisplayString(_unref(animationNum)), 513), [
            [_vShow, _unref(animationNum) > 0]
          ]),
          _withDirectives(_createElementVNode("div", { class: "stu-card-avatar-animation-reduce" }, _toDisplayString(_unref(animationNum)), 513), [
            [_vShow, _unref(animationNum) <= 0]
          ])
        ], 512), [
          [_vShow, _unref(animationVisible)]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _renderSlot(_ctx.$slots, "content-footer", {}, () => [
            (_unref(showScore))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, "+" + _toDisplayString(_unref(score)?.add?.value || 0), 1),
                    _createElementVNode("div", _hoisted_17, " -" + _toDisplayString(_unref(score)?.reduce?.value || 0), 1)
                  ], 512), [
                    [_vShow, 
                  _unref(score) !== undefined &&
                  _unref(score).add?.value !== 0 &&
                  _unref(score).reduce?.value !== 0
                ]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    (_unref(score)?.add?.value !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " +" + _toDisplayString(_unref(score)?.add?.value || 0), 1))
                      : _createCommentVNode("", true),
                    (_unref(score)?.reduce?.value !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, " -" + _toDisplayString(_unref(score)?.reduce?.value || 0), 1))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, 
                  _unref(score) !== undefined &&
                  (_unref(score)?.add?.value === 0 || _unref(score)?.reduce?.value === 0)
                ]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_21, _hoisted_23, 512), [
                    [_vShow, 
                  _unref(score) === undefined ||
                  (_unref(score).add?.value === 0 && _unref(score).reduce?.value === 0)
                ]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _renderSlot(_ctx.$slots, "foot-subscript", {}, () => [
            _withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [
              [_vShow, 
                _unref(isNoAllClass) && _unref(isSelect) && _unref(selectType) === SelectTypeEnum.DOWN
              ]
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      class: "stu-card-name",
      style: _normalizeStyle(_unref(nameStyleCompu))
    }, [
      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(studentInfo).name), 1)
    ], 4)
  ]))
}
}

})